module.exports = __webpack_public_path__ + "media/images/test-image/product-item-big-fbdb4ccbfe6286aa68dc8e54a9b9e3b7.png";